module.exports = __webpack_public_path__ + "img/infograph_5.083a347e.png";